






import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";

@Component({
  components: {}
})
export default class BoxContainer extends Vue {
  @Prop({ default: false })
  private fullWidth?: boolean;
}
